import Vue from 'vue';
import VueRouter from 'vue-router';

import Toast from 'vant/lib/toast';
import Store from '@/store/index';

import Interceptor from '@/router/interceptor';

import Home from '@/views/Home';
import NotSign from '@/views/NotSign';
import BillList from '@/views/bill/BillList';
import BilledDetail from '@/views/bill/BilledDetail';
import MonthBillList from '@/views/bill/MonthBillList';
import MonthBillDetail from '@/views/bill/MonthBillDetail';
import DailyBillDetail from '@/views/bill/DailyBillDetail';
import OtherExpenseDetail from '@/views/bill/OtherExpenseDetail';
import AdjustmentDetail from '@/views/bill/AdjustmentDetail';
import ExportBillAfterTimeNode from '@/views/bill/ExportBillAfterTimeNode';
import AgentInvoiceInfo from '@/views/bill/AgentInvoiceInfo';
import WithholdingConfirm from '@/views/withHoldingConfirm';
import Profit from '@/views/Profit';
import MonthProfit from '@/views/MonthProfit';
import DayProfit from '@/views/DayProfit';
import ActivitySupplement from '@/views/ActivitySupplement';

import Device from '@/views/Device';
import Cooperation from '@/views/Cooperation';
import InvoiceNotice from '@/views/InvoiceNotice';
import InvoiceBill from '@/views/InvoiceBill';
import ContractPdf from '@/views/ContractPdf';
import NoAuth from '@/views/NoAuth';
import Introduction from '@/views/Introduction';
import Settlement from '@/views/Settlement';
import Abnormal from '@/views/Abnormal';
import SupplyAgreement from '@/views/agreement/SupplyAgreement';
import SubjectChangeAgreement from '@/views/agreement/SubjectChangeAgreement';
import AgreementPreviewTemplate from '@/views/agreement/AgreementPreviewTemplate';
import AskForHelp from '@/views/AskForHelp';
import STATUS from '@/constants/status';
import CreateWallet from '@/views/CreateWallet';
import QdbAgreement from '@/views/agreement/QdbAgreement';
import ActivityIndex from '@/views/activity/Index';
import ActivityDetail from '@/views/activity/detail/Detail';
import ActivityMonthBillDetail from '@/views/activity/MonthBillDetail';
import ActivityPoiMonthBillDetail from '@/views/activity/PoiMonthBillDetail';
import ActivityDayBillDetail from '@/views/activity/DayBillDetail';
import ActivityPaidFlow from '@/views/activity/PaidFlow';
import OffsetDetail from '@/views/bill/OffsetDetail';
import ReceivableHistory from '@/views/bill/ReceivableHistory';
import PoiEarn from '@/views/PoiEarn';
import AgentActivityBillList from '@/views/bill/AgentActivityBillList';
import AgentActivityBillDetail from '@/views/bill/AgentActivityBillDetail';
import AgentActivityMonthBillDetail from '@/views/bill/AgentActivityMonthBillDetail';
import AgentActivityDailyBillDetail from '@/views/bill/AgentActivityDailyBillDetail';
import Amortize from '@/views/Amortize';
import Inventory from '@/views/Inventory';
import Cashback from '@/views/Cashback';
import CouponBill from '@/views/bill/CouponBill';
import CouponDetail from '@/views/bill/CouponDetail';
import ErrorAccount from '@/views/ErrorAccount';
import AnalyticsDetail from '@/views/analytics/detail';
import ReferenceInfoList from '@/views/referenceinfo/list';
import ReferenceInfoDetail from '@/views/referenceinfo/detail';
import TaxRecharge from '@/views/bill/TaxRecharge';
import TradeEffectData from '@/views/TradeEffectData';
import BonusAmount from '@/views/bill/BonusAmount';
import CashReward from '@/views/bill/CashReward';
import ServiceLevelPoiDetail from '@/views/serviceLevel/PoiDetail';
import ServiceLevelPoiList from '@/views/serviceLevel/PoiList';
import ServiceLevelPoiListSearch from '@/views/serviceLevel/PoiListSearch';
import ServiceAgreement from '@/views/agreement/ServiceAgreement';
import ForeignInfoCollectionPage from '@/views/bill/ForeignInfoCollectionPage';
import ServiceFeeRefundDetail from '@/views/bill/ServiceFeeRefundDetail';

Vue.use(VueRouter);

const SKIP_PATHS = [
  /abnormal/,
  /noAuth/,
  /settlement/,
  /introduction/,
  /InvoiceNotice/,
  /exportBillAfterTimeNode/,
  /offset\/detail/,
  /receivable\/history/,
  /poiEarn/,
  /errorAccount/,
  /inventory/,
  /withholding-confirm/,
];

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/referenceinfo/list',
    name: 'ReferenceInfoList',
    component: ReferenceInfoList,
    meta: {
      title: '结项报告',
    },
  },
  {
    path: '/referenceinfo/detail',
    name: 'ReferenceInfoDetail',
    component: ReferenceInfoDetail,
    meta: {
      title: '结项报告',
    },
  },
  {
    path: '/analytics/detail',
    name: 'AnalyticsDetail',
    component: AnalyticsDetail,
    meta: {
      title: '流量分析',
    },
  },
  {
    path: '/tradeEffectData',
    name: 'TradeEffectData',
    component: TradeEffectData,
    meta: {
      title: '生意通效果数据',
    },
  },
  {
    path: '/notSign',
    name: 'NotSign',
    component: NotSign,
    meta: {
      title: '待确认签约信息',
    },
  },
  {
    path: '/settlement-tob/billList',
    name: 'BillList',
    component: BillList,
    meta: {
      title: '我的账单',
      keepAlive: true,
    },
  },
  {
    path: '/settlement-tob/billedDetail',
    name: 'BilledDetail',
    component: BilledDetail,
    meta: {
      title: '账单明细',
    },
  },
  {
    path: '/settlement-tob/monthBillList',
    name: 'MonthBillList',
    component: MonthBillList,
    meta: {
      title: '租宝分成',
      keepAlive: true,
    },
  },
  {
    path: '/settlement-tob/monthBillDetail',
    name: 'MonthBillDetail',
    component: MonthBillDetail,
    meta: {
      title: '租宝分成明细',
    },
  },
  {
    path: '/settlement-tob/dailyBillDetail',
    name: 'DailyBillDetail',
    component: DailyBillDetail,
    meta: {
      title: '租宝分成明细',
    },
  },
  {
    path: '/settlement-tob/cashReward',
    name: 'CashReward',
    component: CashReward,
    meta: {
      title: '现金奖励',
    },
  },
  {
    path: '/settlement-tob/otherExpenseDetail',
    name: 'OtherExpenseDetail',
    component: OtherExpenseDetail,
    meta: {
      title: '',
    },
  },
  {
    path: '/settlement-tob/adjustmentDetail',
    name: 'AdjustmentDetail',
    component: AdjustmentDetail,
    meta: {
      title: '调整款项',
    },
  },
  {
    path: '/settlement-tob/agentActivityBillList',
    name: 'AgentActivityBillList',
    component: AgentActivityBillList,
    meta: {
      title: '活动列表',
    },
  },
  {
    path: '/settlement-tob/agentActivityBillDetail',
    name: 'AgentActivityBillDetail',
    component: AgentActivityBillDetail,
    meta: {
      title: '单活动账单',
    },
  },
  {
    path: '/settlement-tob/agentActivityMonthBillDetail',
    name: 'AgentActivityMonthBillDetail',
    component: AgentActivityMonthBillDetail,
    meta: {
      title: '分成账单',
    },
  },
  {
    path: '/settlement-tob/agentActivityDailyBillDetail',
    name: 'AgentActivityDailyBillDetail',
    component: AgentActivityDailyBillDetail,
    meta: {
      title: '单日账单',
    },
  },
  {
    path: '/settlement-tob/amortize',
    name: 'Amortize',
    component: Amortize,
    meta: {
      title: '多宝摊销详情',
    },
  },
  {
    path: '/settlement-tob/cashback',
    name: 'Cashback',
    component: Cashback,
    meta: {
      title: '合作返点',
    },
  },
  {
    path: '/settlement-tob/couponBill',
    name: 'CouponBill',
    component: CouponBill,
    meta: {
      title: '商家券账单',
    },
  },
  {
    path: '/settlement-tob/taxRecharge',
    name: 'TaxRecharge',
    component: TaxRecharge,
    meta: {
      title: '税改补款账单',
    },
  },
  {
    path: '/settlement-tob/couponDetail',
    name: 'CouponDetail',
    component: CouponDetail,
    meta: {
      title: '商家券账单详情',
    },
  },
  {
    path: '/profit',
    name: 'Profit',
    component: Profit,
    meta: {
      title: '我的收益',
    },
  },
  {
    path: '/exportBillAfterTimeNode',
    name: 'ExportBillAfterTimeNode',
    component: ExportBillAfterTimeNode,
    meta: {
      title: '导出账单',
    },
  },
  {
    path: '/settlement-tob/agentInvoiceInfo',
    name: 'AgentInvoiceInfo',
    component: AgentInvoiceInfo,
    meta: {
      title: '开票信息',
    },
  },
  {
    path: '/monthProfit',
    name: 'MonthProfit',
    component: MonthProfit,
    meta: {
      title: '月账单',
    },
  },
  {
    path: '/dayProfit',
    name: 'DayProfit',
    component: DayProfit,
    meta: {
      title: '当日流水',
    },
  },
  {
    path: '/activitySupplement',
    name: 'ActivitySupplement',
    component: ActivitySupplement,
    meta: {
      title: '活动补款',
    },
  },
  {
    path: '/offset/detail',
    name: 'OffsetDetail',
    component: OffsetDetail,
    meta: {
      title: '其他扣减',
    },
  },
  {
    path: '/receivable/history',
    name: 'ReceivableHistory',
    component: ReceivableHistory,
    meta: {
      title: '抵扣',
    },
  },
  {
    path: '/device',
    name: 'Device',
    component: Device,
    meta: {
      title: '设备管理',
    },
  },
  {
    path: '/cooperation',
    name: 'Cooperation',
    component: Cooperation,
    meta: {
      title: '门店信息',
    },
  },
  {
    path: '/contractPdf',
    name: 'contractPdf',
    component: ContractPdf,
    meta: {
      title: '合同预览',
    },
  },
  {
    path: '/invoiceNotice',
    name: 'InvoiceNotice',
    component: InvoiceNotice,
    meta: {
      title: '开票详情',
    },
  },
  {
    path: '/invoiceBill',
    name: 'InvoiceBill',
    component: InvoiceBill,
    meta: {
      title: '待核销账单',
    },
  },
  {
    path: '/withholding-confirm',
    name: 'WithholdingConfirm',
    component: WithholdingConfirm,
    meta: {
      title: '确认代扣服务费说明',
    },
  },
  {
    path: '/introduction',
    name: 'Introduction',
    component: Introduction,
    meta: {
      title: ' ',
    },
  },
  {
    path: '/settlement',
    name: 'Settlement',
    component: Settlement,
    meta: {
      title: '结算卡确认',
    },
  },
  {
    path: '/noAuth',
    name: 'NoAuth',
    component: NoAuth,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/supplyAgreement',
    name: 'SupplyAgreement',
    component: SupplyAgreement,
    meta: {
      title: '补充协议',
    },
  },
  {
    path: '/subjectChangeAgreement',
    name: 'SubjectChangeAgreement',
    component: SubjectChangeAgreement,
    meta: {
      title: '美团充电宝主体变更补充协议',
    },
  },
  {
    path: '/agreementPreviewTemplate/:typeId',
    name: 'AgreementPreviewTemplate',
    component: AgreementPreviewTemplate,
    meta: {
      title: '',
    },
  },
  {
    path: '/askForHelp',
    name: 'AskForHelp',
    component: AskForHelp,
    meta: {
      title: '寻求帮助',
    },
  },
  {
    path: '/createWallet',
    name: 'CreateWallet',
    component: CreateWallet,
    meta: {
      title: '钱包开通',
    },
  },
  {
    path: '/qdbAgreement',
    name: 'qdbAgreement',
    component: QdbAgreement,
    meta: {
      title: '钱袋宝协议',
    },
  },
  {
    path: '/abnormal',
    name: 'Abnormal',
    component: Abnormal,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/activity/index',
    name: 'ActivityIndex',
    component: ActivityIndex,
    meta: {
      title: '活动管理',
    },
  },
  {
    path: '/activity/detail',
    name: 'ActivityDetail',
    component: ActivityDetail,
    meta: {
      title: '活动详情',
    },
  },
  {
    path: '/activity/monthBillDetail',
    name: 'ActivityMonthBillDetail',
    component: ActivityMonthBillDetail,
    meta: {
      title: '账单明细',
    },
  },
  {
    path: '/activity/poiMonthBillDetail',
    name: 'ActivityPoiMonthBillDetail',
    component: ActivityPoiMonthBillDetail,
    meta: {
      title: '账单明细',
    },
  },
  {
    path: '/activity/dayBilldetail',
    name: 'ActivityDayBillDetail',
    component: ActivityDayBillDetail,
    meta: {
      title: '当日流水',
    },
  },
  {
    path: '/activity/paidFlow',
    name: 'ActivityPaidFlow',
    component: ActivityPaidFlow,
    meta: {
      title: '收款详情',
    },
  },
  {
    path: '/poiEarn',
    name: 'PoiEarn',
    component: PoiEarn,
    meta: {
      title: '充电宝提权收益',
    },
  },
  {
    path: '/errorAccount',
    name: 'ErrorAccount',
    component: ErrorAccount,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/inventory',
    name: 'Inventory',
    component: Inventory,
    meta: {
      title: '美团充电宝',
    },
  },
  {
    path: '/settlement-tob/bonusAmount',
    name: 'BonusAmount',
    component: BonusAmount,
    meta: {
      title: '激励账单',
    },
  },
  {
    path: '/service-level/poi-detail',
    name: 'ServiceLevelPoiDetail',
    component: ServiceLevelPoiDetail,
    meta: {
      title: '门店详情',
    },
  },
  {
    path: '/service-level/poi-list',
    name: 'ServiceLevelPoiList',
    component: ServiceLevelPoiList,
    meta: {
      title: '服务等级门店列表',
    },
  },
  {
    path: '/service-level/poi-list-search',
    name: 'ServiceLevelPoiListSearch',
    component: ServiceLevelPoiListSearch,
    meta: {
      title: '服务等级门店列表',
    },
  },
  {
    path: '/agreement/service-agreement',
    name: 'ServiceAgreement',
    component: ServiceAgreement,
    meta: {
      title: '服务协议更新',
    },
  },
  {
    path: '/settlement-tob/foreign-info-collection',
    name: 'ForeignInfoCollectionPage',
    component: ForeignInfoCollectionPage,
    meta: {
      title: '海外人士信息收集',
    },
  },
  {
    path: '/settlement-tob/serviceFeeRefundDetail',
    name: 'ServiceFeeRefundDetail',
    component: ServiceFeeRefundDetail,
    meta: {
      title: '设备运营服务费返还',
    },
  },
  {
    path: '*',
    // route level code-splitting
    // this generates a separate chunk (abnormal.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: Abnormal,
    meta: {
      title: '美团充电宝',
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  if (SKIP_PATHS.some((p) => p.test(to.path))) {
    next();
    return;
  }
  Interceptor.before().then(() => {
    const {
      poiList,
      bizlogintoken,
      adminAccount,
    } = Store.state;
    const { customerId } = Store.state.billModule;
    // 没有token或者没有门店：跳转产品介绍页面
    if (!bizlogintoken || (!poiList.length && !customerId)) {
      if (!bizlogintoken) {
        Toast('没有token，无法展示页面');
      } else if (!poiList.length) {
        Toast('您还没有门店');
      } else {
        Toast('没有客户ID');
      }
      next({
        path: '/introduction',
        replace: true,
      });
      return;
    }
    if (adminAccount && !adminAccount.success) {
      Toast('管理员账号错误');
      next({
        path: '/errorAccount',
        replace: true,
      });
      return;
    }

    // 当前poiId未签约，有待签约信息，且跳转的不是notSign
    // if (!signFlag && signInfo.length && to.path !== '/notSign') {
    //   next({
    //     path: '/notSign', // 未签约页面
    //     replace: true,
    //   });
    //   return;
    // }

    next();
  }).catch((Error) => {
    const bizlogintoken = Store.state.bizlogintoken;
    const customerId = Store.state.billModule.customerId;
    let error = {};
    if (typeof Error.message === 'string') {
      error = JSON.parse(Error.message);
    }
    const options = {
      tags: {
        bizlogintoken,
        customerId,
        from: 'route interceptor',
        path: error.path,
        errCode: error.code,
      },
    };
    Owl.addError('noAuth', options);
    if (error.code === STATUS.AUTH_ERROR || error.code === STATUS.GATEWAY_AUTH_ERROR) {
      next({
        path: '/noAuth',
        replace: true,
      });
    } else {
      next({
        path: `/abnormal?code=${error.code}`,
        replace: true,
      });
    }
  });
});

export default router;
